import type {
  SiteAutodiagDeviceDiagnosticResult,
  SiteAutodiagDeviceInfo,
  SiteAutodiagDeviceProgrammingConformState,
  SiteAutodiagDeviceProgrammingMode,
  SiteAutodiagDeviceProgrammingType,
} from "~domain/sites/models/site-autodiag-model.ts";

const test: Record<SiteAutodiagDeviceDiagnosticResult, string> = {
  OK: "Pilotage OK",
  NOK_NO_POWER: "Appareil: Conso faible",
  NOK_NO_MODULATION: "Appareil : Échec de pilotage",
  NOK_UNREACHABLE: "Module: Échec de connexion",
  NOK_DEVICE_UNKNOWN: "Module: Échec de connexion",
  FAILED_BACKEND: "Échec Infra Voltalis",
};

const energyManager: Record<NonNullable<SiteAutodiagDeviceInfo["hasEnergyManager"]>, string> = {
  HAS_ENERGY_MANAGER: "Détecté",
  NO_ENERGY_MANAGER: "Non détecté",
  ERROR_INFRA_VOLTALIS: "Échec Infra Voltalis",
};

const conformity: Record<SiteAutodiagDeviceProgrammingConformState, string> = {
  NOT_CONFORM: "Non conforme",
  CONFORM: "Conforme",
  FAILED: "Failure Voltalis Infra",
};

const myvMode: Record<SiteAutodiagDeviceProgrammingMode, string> = {
  NORMAL: "Marche",
  CONFORT: "Confort",
  CONFORTMINUS1: "Confort -1",
  CONFORTMINUS2: "Confort -2",
  ECO: "Eco",
  ECOV: "Eco V",
  HORS_GEL: "Hors Gel",
  TEMPERATURE: "Temperature",
  ARRET: "Stop",
  UNKNOWN: "Inconnu",
  ERROR: "Erreur",
};

const myvType: Record<SiteAutodiagDeviceProgrammingType, string> = {
  DEFAULT: "Défaut",
  USER: "Programme",
  QUICK: "Rapide",
  MANUAL: "Manuel",
  UNKNOWN: "Inconnu",
  ERROR: "Erreur",
};

export const SITE_AUTODIAG_TABLE_FRENCH_LOCALE = {
  empty: "Aucun appareil",
  syncMyVProgrammingButton: "Synchroniser programmation MyV",
  headers: {
    name: "Nom de l'appareil",
    result: "Résultat",
    start: "Date de début",
    end: "Date de fin",
    energyManager: "Gestionnaire d'énergie",
    programmingMode: "Mode MyV",
    programmingType: "Type MyV",
    programmingState: "Synchronisation",
    help: "Aide",
    actions: "Actions",
    launchDiag: "Diag",
  },
  test,
  energyManager,
  conformity,
  myvMode,
  myvType,

  sensorPopover: {
    serial: "Numéro de série",
    hwId: "Hw ID",
    csId: "Cs ID",
    installationDate: "Date d'installation",
  },
};
